export enum AccessibilityState {
  private = 'PRIVATE',
  public = 'PUBLIC',
  both = 'BOTH',
  none = 'NONE'
}
